"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Styles = require("../00_environment/Styles");

var _RidesListItem = _interopRequireDefault(require("./RidesListItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RidesList = function RidesList(_ref) {
  var rides = _ref.rides,
      _ref$numberOfPassenge = _ref.numberOfPassengers,
      numberOfPassengers = _ref$numberOfPassenge === void 0 ? 1 : _ref$numberOfPassenge,
      _ref$onRideClick = _ref.onRideClick,
      onRideClick = _ref$onRideClick === void 0 ? function () {} : _ref$onRideClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _Styles.ridesListStyle
  }, rides.map(function (r) {
    return /*#__PURE__*/_react["default"].createElement(_RidesListItem["default"], {
      id: "ride_".concat(r.id),
      key: "ride_".concat(r.id),
      ride: r,
      numberOfPassengers: numberOfPassengers,
      onRideClick: onRideClick
    });
  }));
};

var _default = RidesList;
exports["default"] = _default;